// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.JsFormatService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import {highcharts as Highcharts} from 'wrappers/Izenda.Highcharts';

const isFormatString = value => /\{(.*)\}/.test(value);

class JsFormatService {
  jsFormats = new Map();
  jsFormatStringList = new Map();

  /**
   * Add a JS format function associated with a format string name
   */
  addJsFormat(formatName: string, formatFn: any): void {
    this.jsFormats.set(formatName, formatFn);
  }

  removeJsFormat(formatName: string): void {
    this.jsFormats.delete(formatName);
  }

  /**
   * Add a JS js format string associated with a format string name
   */
  registerJsFormatString(formatName: string, formatString: string): void {
    this.jsFormatStringList.set(formatName, formatString);
  }

  removeJsFormatString(formatName: string): void {
    this.jsFormatStringList.delete(formatName);
  }

  format(formatName: string, value: any, originalValue: string = null): any {
    const jsFormatString = this.jsFormatStringList.get(formatName);

    if (isFormatString(jsFormatString)) {
      return Highcharts.format(jsFormatString, { value });
    }

    const formatFn = this.jsFormats.get(jsFormatString);
    if (!formatFn)
      return originalValue ? originalValue : value;

    return formatFn(value);
  }
}

export default new JsFormatService();



// WEBPACK FOOTER //
// ./ui/share/Izenda.JsFormatService.js